import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'components/FontIcon';
import classNames from 'classnames';
import AlertAClasses from './AlertA.module.scss';
import AlertBClasses from './AlertB.module.scss';
import AlertCClasses from './AlertC.module.scss';
import AlertDClasses from './AlertD.module.scss';
import Button from '../Button/Button';

const Alert = (props) => {
  const {
    id,
    type,
    description,
    dismissible,
    closeButtonTitle = 'Close',
    cssClass,
    onClose,
  } = props;

  const alertClasses = {
    AlertA: AlertAClasses,
    AlertB: AlertBClasses,
    AlertC: AlertCClasses,
    AlertD: AlertDClasses,
  };

  const classes = alertClasses[type];

  const createButton = (type === 'AlertD')
    ? (
      <Button
        subType='ButtonA'
        title={closeButtonTitle}
        onClick={() => onClose(id)}
      />
    ) : (
      <button aria-label='Close' onClick={() => onClose(id)} type='button'>
        <FontIcon className={classes.icon} icon='far fa-times' />
      </button>
    );

  return (
    <div className={classNames(classes.container, cssClass)}>
      <div className={classes.wrapper}>
        {description && <div className={classes.description} dangerouslySetInnerHTML={{ __html: description }} />}
        {dismissible &&
          <span className={classes.close}>
            {createButton}
          </span>}
      </div>
    </div>
  );
};

Alert.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string.isRequired,
  description: PropTypes.string,
  dismissible: PropTypes.bool,
  closeButtonTitle: PropTypes.string,
  cssClass: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default Alert;
